/**
 * Utilidades compartidas para validación y transformación de rule groups (DTO <-> estado del drawer).
 */

/** Transforma children del DTO al formato del drawer (preserva id para edición). */
export const transformChildrenFromDto = (childrenDto) => {
  if (!childrenDto || !Array.isArray(childrenDto)) return [];
  return childrenDto.map((child) => ({
    ...(child.id != null && { id: child.id }),
    operator: child.operator || 'and',
    rules: (child.rules || []).map((rule) => {
      const fieldId = typeof rule.field === 'object' ? rule.field?.id : rule.field;
      return {
        ...(rule.id != null && { id: rule.id }),
        field: fieldId,
        operator: rule.operator,
        value: rule.value,
      };
    }),
    children: transformChildrenFromDto(child.children),
  }));
};

/** Valida una regla individual. */
export const isValidRule = (rule) => {
  if (!rule.field || !rule.operator) return false;

  if (rule.operator === 'between') {
    return Array.isArray(rule.value) && rule.value.length === 2 && rule.value[0] != null && rule.value[1] != null;
  }

  if (rule.operator === 'in' || rule.operator === 'not_in') {
    return Array.isArray(rule.value) && rule.value.length > 0;
  }

  return rule.value !== undefined && rule.value !== null && rule.value !== '';
};

/** Valida un grupo: true si tiene al menos una regla válida O un child válido. */
export const validateGroup = (group) => {
  const hasValidRules = group.rules && group.rules.some(isValidRule);
  const hasValidChildren = group.children && group.children.some(validateGroup);
  return hasValidRules || hasValidChildren;
};

/** Valida que todas las reglas y grupos estén completos (sin reglas incompletas). */
export const validateAllRulesAndGroups = (group) => {
  if (group.rules && group.rules.length > 0) {
    const hasIncompleteRules = group.rules.some((rule) => !isValidRule(rule));
    if (hasIncompleteRules) return false;
  }

  if (group.children && group.children.length > 0) {
    const hasInvalidChildren = group.children.some((child) => !validateAllRulesAndGroups(child));
    if (hasInvalidChildren) return false;
  }

  return validateGroup(group);
};

/** Transforma children del drawer al formato DTO (incluye id para update). */
export const transformChildrenToDto = (childrenData) => {
  if (!childrenData || !Array.isArray(childrenData)) return [];
  return childrenData.map((child) => ({
    ...(child.id != null && { id: child.id }),
    operator: child.operator,
    rules: (child.rules || []).map((rule) => ({
      ...(rule.id != null && { id: rule.id }),
      field: rule.field,
      operator: rule.operator,
      value: rule.value,
    })),
    children: transformChildrenToDto(child.children),
  }));
};
